import type { TypeSelectProps } from '@thefarmersfront/kitchen';

/**
 * 테이블 셀 Select의 dropdown placement를 계산하는 함수
 * - 마지막 N개 행(기본 3)부터 `edgePlacement` 적용
 * - 단, `thresholdRow`(기본 1) 이전 행에는 적용하지 않음
 * - 기본 placement는 'bottom-left'
 */
const getSelectPlacement = (
  rowIndex: number | null,
  dataLength: number,
  options?: {
    /**
     * 임계 행(1-base). 이 이전은 `edgePlacement` 미적용
     * @default 1
     */
    thresholdRow?: number;
    /**
     * 마지막 구간에 적용할 placement
     * @default 'top-left'
     */
    edgePlacement?: TypeSelectProps['dropdownPlacement'];
    /**
     * 끝에서부터 `edgePlacement`를 적용할 행 수
     * @default 3
     */
    lastN?: number;
  }
) => {
  const defaultPlacement = 'bottom-left';
  const edgePlacement = options?.edgePlacement ?? 'top-left';
  const lastN = options?.lastN ?? 3;
  const thresholdRow = options?.thresholdRow ?? 1;

  if (rowIndex === null || rowIndex === undefined) {
    return defaultPlacement;
  }

  const lastNStartIndex = Math.max(dataLength - lastN, 0);
  const thresholdIndex = Math.max(thresholdRow - 1, 0);
  const startIndex = Math.max(thresholdIndex, lastNStartIndex);

  return rowIndex >= startIndex ? edgePlacement : defaultPlacement;
};

export default getSelectPlacement;
